import { Footer, Services} from '../container';
import PageHero from "../components/PageHero/PageHero";
import aboutBg from "../assets/bgimage.jpg";
export default function ServicesPage() {
  return <>
  <PageHero title="Services" bgImage={aboutBg} />
  <Services />
  <Footer/></>;
}
